module.exports = __webpack_public_path__ + "img/logo.b148793e.png";